// Who holds a tray, in the GET /tray/holder shape:
//   { is_locked, locked_type: "droplist" | "picklist" | null, locked_id, locked_no }
// Tray list rows carry the same facts as separate drop list / pick list columns;
// holderFromRow folds them into that shape so the tooltip can show the list's
// answer at once and swap in the server's fresh one when it arrives.

const DOCUMENT_TYPE_LABELS = { droplist: "Drop list", picklist: "Pick list" };

/** True when the list row says a drop list or pick list holds the tray. */
export const isTrayHeld = (tray) => Boolean(tray?.is_droplist_locked || tray?.is_picklist_locked);

/**
 * A tray list row's holder in the /tray/holder shape. Trays are shared, so only
 * one document can hold one; if older data has both, the drop list is reported,
 * the same as the server.
 */
export const holderFromRow = (tray) => {
  if (tray?.is_droplist_locked) {
    return { is_locked: true, locked_type: "droplist", locked_id: tray.drop_list_id, locked_no: tray.drop_list_no };
  }
  if (tray?.is_picklist_locked) {
    return { is_locked: true, locked_type: "picklist", locked_id: tray.pick_list_id, locked_no: tray.pick_list_no };
  }
  return { is_locked: false, locked_type: null, locked_id: null, locked_no: null };
};

/** Tooltip text, e.g. "Reserved by Drop list DL-0012". */
export const holderLabel = (holder) => {
  if (!holder?.is_locked) return "Not reserved by any document";
  const type = DOCUMENT_TYPE_LABELS[holder.locked_type] || "Document";
  return `Reserved by ${type} ${holder.locked_no || holder.locked_id || ""}`.trim();
};
